var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58333 11.0827C1.16341 11.0827 0.76068 10.9159 0.463748 10.6189C0.166815 10.322 0 9.91928 0 9.49935C0 9.07942 0.166815 8.6767 0.463748 8.37976C0.76068 8.08283 1.16341 7.91602 1.58333 7.91602H17.4167C17.8366 7.91602 18.2393 8.08283 18.5363 8.37976C18.8332 8.6767 19 9.07942 19 9.49935C19 9.91928 18.8332 10.322 18.5363 10.6189C18.2393 10.9159 17.8366 11.0827 17.4167 11.0827H1.58333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91675 1.58333C7.91675 1.16341 8.08356 0.76068 8.3805 0.463748C8.67743 0.166815 9.08016 0 9.50008 0C9.92001 0 10.3227 0.166815 10.6197 0.463748C10.9166 0.76068 11.0834 1.16341 11.0834 1.58333V17.4167C11.0834 17.8366 10.9166 18.2393 10.6197 18.5363C10.3227 18.8332 9.92001 19 9.50008 19C9.08016 19 8.67743 18.8332 8.3805 18.5363C8.08356 18.2393 7.91675 17.8366 7.91675 17.4167V1.58333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonWhite);
export default __webpack_public_path__ + "static/media/+ButtonWhite.82c7792c5408e4761c6f1cae47ffe454.svg";
export { ForwardRef as ReactComponent };